import { IUtilFunctions } from "./iutil-functions";
//import { ESignalType } from "./enum-sig-types";
import { TSignalNonStandardTypeName } from "@crestron/ch5-crcomlib";
import { TAllSignalSubscriptionUpdateCallbacks } from "@crestron/ch5-crcomlib/build_bundles/umd/@types/ch5-core/types/callbacks";

export class CrComLibAdaptor implements IUtilFunctions {

  /**
   *
   */
  constructor(private _CrComLib: any) {
        
  }

  subscribeState(
    signalType: string,
    signalName: string,
    callback: Function
  ): string {
    return this._CrComLib.subscribeState(signalType as TSignalNonStandardTypeName, signalName, callback as TAllSignalSubscriptionUpdateCallbacks)
  }
  publishEvent(
    signalType: string,
    signalName: string,
    value: string | number | boolean | object
  ): void {
    this._CrComLib.publishEvent(signalType as TSignalNonStandardTypeName, signalName, value)
  }
}
